import { Component } from '@angular/core';

@Component({
  selector: 'app-cards',
  templateUrl: './cards.component.html',
  styleUrls: ['./cards.component.scss']
})
export class CardsPageComponent {
  constructor() {}

  isLoading = false;
  errorMessage = false;
  message = 'Something went terribly wrong. Just keep calm and carry on!';

  errorCard_isLoading = false;
  errorCard_errorMessage = false;
  errorCard_message = 'Something went terribly wrong.';

  errorCardSampleRefresh() {
    this.errorCard_isLoading = true;
    this.errorCard_errorMessage = false;
    setTimeout(() => {
      this.errorCard_isLoading = false;
      this.errorCard_errorMessage = true;
    }, 3000);
  }

  sampleRefresh() {
    this.isLoading = true;
    this.errorMessage = false;
    setTimeout(() => {
      this.isLoading = false;
      this.errorMessage = true;
    }, 3000);
  }
}
